import { useUserSetting } from '../../../hooks/use-user-setting';
import { HomePageFeedCompletedCards } from '../components/engagement-section/home-page-constants';

export const useIsCardComplete = (id) => {
  const userHomePageFeedCompletedCards = useUserSetting(HomePageFeedCompletedCards) || '[]';
  const parsedCompletedCards = JSON.parse(userHomePageFeedCompletedCards);
  return parsedCompletedCards.includes(id);
};
